import * as i0 from '@angular/core';
import { Component, SkipSelf, Host, Input, NgModule, ContentChildren, Inject, Output } from '@angular/core';
import * as i1 from 'devextreme-angular/core';
import { NestedOption, NestedOptionHost, DxIntegrationModule, CollectionNestedOption, extractTemplate, DxTemplateHost } from 'devextreme-angular/core';
import { PROPERTY_TOKEN_commands, PROPERTY_TOKEN_items, PROPERTY_TOKEN_connectionPoints, PROPERTY_TOKEN_customShapes, PROPERTY_TOKEN_groups, PROPERTY_TOKEN_tabs } from 'devextreme-angular/core/tokens';
import { DOCUMENT } from '@angular/common';

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
const _c0 = ["*"];
let DxoDiagramAutoLayoutComponent = /*#__PURE__*/(() => {
  class DxoDiagramAutoLayoutComponent extends NestedOption {
    get orientation() {
      return this._getOption('orientation');
    }
    set orientation(value) {
      this._setOption('orientation', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get _optionPath() {
      return 'autoLayout';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDiagramAutoLayoutComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDiagramAutoLayoutComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDiagramAutoLayoutComponent,
      selectors: [["dxo-diagram-auto-layout"]],
      inputs: {
        orientation: "orientation",
        type: "type"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDiagramAutoLayoutComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDiagramAutoLayoutComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDiagramAutoLayoutModule = /*#__PURE__*/(() => {
  class DxoDiagramAutoLayoutModule {
    /** @nocollapse */static ɵfac = function DxoDiagramAutoLayoutModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDiagramAutoLayoutModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDiagramAutoLayoutModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDiagramAutoLayoutComponent]
    });
  }
  return DxoDiagramAutoLayoutModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiDiagramCommandComponent = /*#__PURE__*/(() => {
  class DxiDiagramCommandComponent extends CollectionNestedOption {
    set _itemsContentChildren(value) {
      this.setChildren('items', value);
    }
    get icon() {
      return this._getOption('icon');
    }
    set icon(value) {
      this._setOption('icon', value);
    }
    get items() {
      return this._getOption('items');
    }
    set items(value) {
      this._setOption('items', value);
    }
    get location() {
      return this._getOption('location');
    }
    set location(value) {
      this._setOption('location', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get _optionPath() {
      return 'commands';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiDiagramCommandComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDiagramCommandComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiDiagramCommandComponent,
      selectors: [["dxi-diagram-command"]],
      contentQueries: function DxiDiagramCommandComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_items, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._itemsContentChildren = _t);
        }
      },
      inputs: {
        icon: "icon",
        items: "items",
        location: "location",
        name: "name",
        text: "text"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_commands,
        useExisting: DxiDiagramCommandComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiDiagramCommandComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiDiagramCommandComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiDiagramCommandModule = /*#__PURE__*/(() => {
  class DxiDiagramCommandModule {
    /** @nocollapse */static ɵfac = function DxiDiagramCommandModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDiagramCommandModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiDiagramCommandModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiDiagramCommandComponent]
    });
  }
  return DxiDiagramCommandModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiDiagramCommandItemComponent = /*#__PURE__*/(() => {
  class DxiDiagramCommandItemComponent extends CollectionNestedOption {
    set _itemsContentChildren(value) {
      this.setChildren('items', value);
    }
    get icon() {
      return this._getOption('icon');
    }
    set icon(value) {
      this._setOption('icon', value);
    }
    get items() {
      return this._getOption('items');
    }
    set items(value) {
      this._setOption('items', value);
    }
    get location() {
      return this._getOption('location');
    }
    set location(value) {
      this._setOption('location', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get _optionPath() {
      return 'items';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiDiagramCommandItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDiagramCommandItemComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiDiagramCommandItemComponent,
      selectors: [["dxi-diagram-command-item"]],
      contentQueries: function DxiDiagramCommandItemComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_items, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._itemsContentChildren = _t);
        }
      },
      inputs: {
        icon: "icon",
        items: "items",
        location: "location",
        name: "name",
        text: "text"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_items,
        useExisting: DxiDiagramCommandItemComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiDiagramCommandItemComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiDiagramCommandItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiDiagramCommandItemModule = /*#__PURE__*/(() => {
  class DxiDiagramCommandItemModule {
    /** @nocollapse */static ɵfac = function DxiDiagramCommandItemModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDiagramCommandItemModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiDiagramCommandItemModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiDiagramCommandItemComponent]
    });
  }
  return DxiDiagramCommandItemModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiDiagramConnectionPointComponent = /*#__PURE__*/(() => {
  class DxiDiagramConnectionPointComponent extends CollectionNestedOption {
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get _optionPath() {
      return 'connectionPoints';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiDiagramConnectionPointComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDiagramConnectionPointComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiDiagramConnectionPointComponent,
      selectors: [["dxi-diagram-connection-point"]],
      inputs: {
        x: "x",
        y: "y"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_connectionPoints,
        useExisting: DxiDiagramConnectionPointComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiDiagramConnectionPointComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiDiagramConnectionPointComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiDiagramConnectionPointModule = /*#__PURE__*/(() => {
  class DxiDiagramConnectionPointModule {
    /** @nocollapse */static ɵfac = function DxiDiagramConnectionPointModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDiagramConnectionPointModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiDiagramConnectionPointModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiDiagramConnectionPointComponent]
    });
  }
  return DxiDiagramConnectionPointModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDiagramContextMenuComponent = /*#__PURE__*/(() => {
  class DxoDiagramContextMenuComponent extends NestedOption {
    set _commandsContentChildren(value) {
      this.setChildren('commands', value);
    }
    get commands() {
      return this._getOption('commands');
    }
    set commands(value) {
      this._setOption('commands', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get _optionPath() {
      return 'contextMenu';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDiagramContextMenuComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDiagramContextMenuComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDiagramContextMenuComponent,
      selectors: [["dxo-diagram-context-menu"]],
      contentQueries: function DxoDiagramContextMenuComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_commands, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._commandsContentChildren = _t);
        }
      },
      inputs: {
        commands: "commands",
        enabled: "enabled"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDiagramContextMenuComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDiagramContextMenuComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDiagramContextMenuModule = /*#__PURE__*/(() => {
  class DxoDiagramContextMenuModule {
    /** @nocollapse */static ɵfac = function DxoDiagramContextMenuModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDiagramContextMenuModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDiagramContextMenuModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDiagramContextMenuComponent]
    });
  }
  return DxoDiagramContextMenuModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDiagramContextToolboxComponent = /*#__PURE__*/(() => {
  class DxoDiagramContextToolboxComponent extends NestedOption {
    get category() {
      return this._getOption('category');
    }
    set category(value) {
      this._setOption('category', value);
    }
    get displayMode() {
      return this._getOption('displayMode');
    }
    set displayMode(value) {
      this._setOption('displayMode', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get shapeIconsPerRow() {
      return this._getOption('shapeIconsPerRow');
    }
    set shapeIconsPerRow(value) {
      this._setOption('shapeIconsPerRow', value);
    }
    get shapes() {
      return this._getOption('shapes');
    }
    set shapes(value) {
      this._setOption('shapes', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'contextToolbox';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDiagramContextToolboxComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDiagramContextToolboxComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDiagramContextToolboxComponent,
      selectors: [["dxo-diagram-context-toolbox"]],
      inputs: {
        category: "category",
        displayMode: "displayMode",
        enabled: "enabled",
        shapeIconsPerRow: "shapeIconsPerRow",
        shapes: "shapes",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDiagramContextToolboxComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDiagramContextToolboxComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDiagramContextToolboxModule = /*#__PURE__*/(() => {
  class DxoDiagramContextToolboxModule {
    /** @nocollapse */static ɵfac = function DxoDiagramContextToolboxModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDiagramContextToolboxModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDiagramContextToolboxModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDiagramContextToolboxComponent]
    });
  }
  return DxoDiagramContextToolboxModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiDiagramCustomShapeComponent = /*#__PURE__*/(() => {
  class DxiDiagramCustomShapeComponent extends CollectionNestedOption {
    renderer;
    document;
    element;
    set _connectionPointsContentChildren(value) {
      this.setChildren('connectionPoints', value);
    }
    get allowEditImage() {
      return this._getOption('allowEditImage');
    }
    set allowEditImage(value) {
      this._setOption('allowEditImage', value);
    }
    get allowEditText() {
      return this._getOption('allowEditText');
    }
    set allowEditText(value) {
      this._setOption('allowEditText', value);
    }
    get allowResize() {
      return this._getOption('allowResize');
    }
    set allowResize(value) {
      this._setOption('allowResize', value);
    }
    get backgroundImageHeight() {
      return this._getOption('backgroundImageHeight');
    }
    set backgroundImageHeight(value) {
      this._setOption('backgroundImageHeight', value);
    }
    get backgroundImageLeft() {
      return this._getOption('backgroundImageLeft');
    }
    set backgroundImageLeft(value) {
      this._setOption('backgroundImageLeft', value);
    }
    get backgroundImageToolboxUrl() {
      return this._getOption('backgroundImageToolboxUrl');
    }
    set backgroundImageToolboxUrl(value) {
      this._setOption('backgroundImageToolboxUrl', value);
    }
    get backgroundImageTop() {
      return this._getOption('backgroundImageTop');
    }
    set backgroundImageTop(value) {
      this._setOption('backgroundImageTop', value);
    }
    get backgroundImageUrl() {
      return this._getOption('backgroundImageUrl');
    }
    set backgroundImageUrl(value) {
      this._setOption('backgroundImageUrl', value);
    }
    get backgroundImageWidth() {
      return this._getOption('backgroundImageWidth');
    }
    set backgroundImageWidth(value) {
      this._setOption('backgroundImageWidth', value);
    }
    get baseType() {
      return this._getOption('baseType');
    }
    set baseType(value) {
      this._setOption('baseType', value);
    }
    get category() {
      return this._getOption('category');
    }
    set category(value) {
      this._setOption('category', value);
    }
    get connectionPoints() {
      return this._getOption('connectionPoints');
    }
    set connectionPoints(value) {
      this._setOption('connectionPoints', value);
    }
    get defaultHeight() {
      return this._getOption('defaultHeight');
    }
    set defaultHeight(value) {
      this._setOption('defaultHeight', value);
    }
    get defaultImageUrl() {
      return this._getOption('defaultImageUrl');
    }
    set defaultImageUrl(value) {
      this._setOption('defaultImageUrl', value);
    }
    get defaultText() {
      return this._getOption('defaultText');
    }
    set defaultText(value) {
      this._setOption('defaultText', value);
    }
    get defaultWidth() {
      return this._getOption('defaultWidth');
    }
    set defaultWidth(value) {
      this._setOption('defaultWidth', value);
    }
    get imageHeight() {
      return this._getOption('imageHeight');
    }
    set imageHeight(value) {
      this._setOption('imageHeight', value);
    }
    get imageLeft() {
      return this._getOption('imageLeft');
    }
    set imageLeft(value) {
      this._setOption('imageLeft', value);
    }
    get imageTop() {
      return this._getOption('imageTop');
    }
    set imageTop(value) {
      this._setOption('imageTop', value);
    }
    get imageWidth() {
      return this._getOption('imageWidth');
    }
    set imageWidth(value) {
      this._setOption('imageWidth', value);
    }
    get keepRatioOnAutoSize() {
      return this._getOption('keepRatioOnAutoSize');
    }
    set keepRatioOnAutoSize(value) {
      this._setOption('keepRatioOnAutoSize', value);
    }
    get maxHeight() {
      return this._getOption('maxHeight');
    }
    set maxHeight(value) {
      this._setOption('maxHeight', value);
    }
    get maxWidth() {
      return this._getOption('maxWidth');
    }
    set maxWidth(value) {
      this._setOption('maxWidth', value);
    }
    get minHeight() {
      return this._getOption('minHeight');
    }
    set minHeight(value) {
      this._setOption('minHeight', value);
    }
    get minWidth() {
      return this._getOption('minWidth');
    }
    set minWidth(value) {
      this._setOption('minWidth', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get templateHeight() {
      return this._getOption('templateHeight');
    }
    set templateHeight(value) {
      this._setOption('templateHeight', value);
    }
    get templateLeft() {
      return this._getOption('templateLeft');
    }
    set templateLeft(value) {
      this._setOption('templateLeft', value);
    }
    get templateTop() {
      return this._getOption('templateTop');
    }
    set templateTop(value) {
      this._setOption('templateTop', value);
    }
    get templateWidth() {
      return this._getOption('templateWidth');
    }
    set templateWidth(value) {
      this._setOption('templateWidth', value);
    }
    get textHeight() {
      return this._getOption('textHeight');
    }
    set textHeight(value) {
      this._setOption('textHeight', value);
    }
    get textLeft() {
      return this._getOption('textLeft');
    }
    set textLeft(value) {
      this._setOption('textLeft', value);
    }
    get textTop() {
      return this._getOption('textTop');
    }
    set textTop(value) {
      this._setOption('textTop', value);
    }
    get textWidth() {
      return this._getOption('textWidth');
    }
    set textWidth(value) {
      this._setOption('textWidth', value);
    }
    get title() {
      return this._getOption('title');
    }
    set title(value) {
      this._setOption('title', value);
    }
    get toolboxTemplate() {
      return this._getOption('toolboxTemplate');
    }
    set toolboxTemplate(value) {
      this._setOption('toolboxTemplate', value);
    }
    get toolboxWidthToHeightRatio() {
      return this._getOption('toolboxWidthToHeightRatio');
    }
    set toolboxWidthToHeightRatio(value) {
      this._setOption('toolboxWidthToHeightRatio', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get _optionPath() {
      return 'customShapes';
    }
    constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
      super();
      this.renderer = renderer;
      this.document = document;
      this.element = element;
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      templateHost.setHost(this);
    }
    setTemplate(template) {
      this.template = template;
    }
    ngAfterViewInit() {
      extractTemplate(this, this.element, this.renderer, this.document);
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiDiagramCustomShapeComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDiagramCustomShapeComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiDiagramCustomShapeComponent,
      selectors: [["dxi-diagram-custom-shape"]],
      contentQueries: function DxiDiagramCustomShapeComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_connectionPoints, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._connectionPointsContentChildren = _t);
        }
      },
      inputs: {
        allowEditImage: "allowEditImage",
        allowEditText: "allowEditText",
        allowResize: "allowResize",
        backgroundImageHeight: "backgroundImageHeight",
        backgroundImageLeft: "backgroundImageLeft",
        backgroundImageToolboxUrl: "backgroundImageToolboxUrl",
        backgroundImageTop: "backgroundImageTop",
        backgroundImageUrl: "backgroundImageUrl",
        backgroundImageWidth: "backgroundImageWidth",
        baseType: "baseType",
        category: "category",
        connectionPoints: "connectionPoints",
        defaultHeight: "defaultHeight",
        defaultImageUrl: "defaultImageUrl",
        defaultText: "defaultText",
        defaultWidth: "defaultWidth",
        imageHeight: "imageHeight",
        imageLeft: "imageLeft",
        imageTop: "imageTop",
        imageWidth: "imageWidth",
        keepRatioOnAutoSize: "keepRatioOnAutoSize",
        maxHeight: "maxHeight",
        maxWidth: "maxWidth",
        minHeight: "minHeight",
        minWidth: "minWidth",
        template: "template",
        templateHeight: "templateHeight",
        templateLeft: "templateLeft",
        templateTop: "templateTop",
        templateWidth: "templateWidth",
        textHeight: "textHeight",
        textLeft: "textLeft",
        textTop: "textTop",
        textWidth: "textWidth",
        title: "title",
        toolboxTemplate: "toolboxTemplate",
        toolboxWidthToHeightRatio: "toolboxWidthToHeightRatio",
        type: "type"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost, {
        provide: PROPERTY_TOKEN_customShapes,
        useExisting: DxiDiagramCustomShapeComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function DxiDiagramCustomShapeComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      dependencies: [DxIntegrationModule],
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
  return DxiDiagramCustomShapeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiDiagramCustomShapeModule = /*#__PURE__*/(() => {
  class DxiDiagramCustomShapeModule {
    /** @nocollapse */static ɵfac = function DxiDiagramCustomShapeModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDiagramCustomShapeModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiDiagramCustomShapeModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiDiagramCustomShapeComponent]
    });
  }
  return DxiDiagramCustomShapeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDiagramDefaultItemPropertiesComponent = /*#__PURE__*/(() => {
  class DxoDiagramDefaultItemPropertiesComponent extends NestedOption {
    get connectorLineEnd() {
      return this._getOption('connectorLineEnd');
    }
    set connectorLineEnd(value) {
      this._setOption('connectorLineEnd', value);
    }
    get connectorLineStart() {
      return this._getOption('connectorLineStart');
    }
    set connectorLineStart(value) {
      this._setOption('connectorLineStart', value);
    }
    get connectorLineType() {
      return this._getOption('connectorLineType');
    }
    set connectorLineType(value) {
      this._setOption('connectorLineType', value);
    }
    get shapeMaxHeight() {
      return this._getOption('shapeMaxHeight');
    }
    set shapeMaxHeight(value) {
      this._setOption('shapeMaxHeight', value);
    }
    get shapeMaxWidth() {
      return this._getOption('shapeMaxWidth');
    }
    set shapeMaxWidth(value) {
      this._setOption('shapeMaxWidth', value);
    }
    get shapeMinHeight() {
      return this._getOption('shapeMinHeight');
    }
    set shapeMinHeight(value) {
      this._setOption('shapeMinHeight', value);
    }
    get shapeMinWidth() {
      return this._getOption('shapeMinWidth');
    }
    set shapeMinWidth(value) {
      this._setOption('shapeMinWidth', value);
    }
    get style() {
      return this._getOption('style');
    }
    set style(value) {
      this._setOption('style', value);
    }
    get textStyle() {
      return this._getOption('textStyle');
    }
    set textStyle(value) {
      this._setOption('textStyle', value);
    }
    get _optionPath() {
      return 'defaultItemProperties';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDiagramDefaultItemPropertiesComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDiagramDefaultItemPropertiesComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDiagramDefaultItemPropertiesComponent,
      selectors: [["dxo-diagram-default-item-properties"]],
      inputs: {
        connectorLineEnd: "connectorLineEnd",
        connectorLineStart: "connectorLineStart",
        connectorLineType: "connectorLineType",
        shapeMaxHeight: "shapeMaxHeight",
        shapeMaxWidth: "shapeMaxWidth",
        shapeMinHeight: "shapeMinHeight",
        shapeMinWidth: "shapeMinWidth",
        style: "style",
        textStyle: "textStyle"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDiagramDefaultItemPropertiesComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDiagramDefaultItemPropertiesComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDiagramDefaultItemPropertiesModule = /*#__PURE__*/(() => {
  class DxoDiagramDefaultItemPropertiesModule {
    /** @nocollapse */static ɵfac = function DxoDiagramDefaultItemPropertiesModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDiagramDefaultItemPropertiesModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDiagramDefaultItemPropertiesModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDiagramDefaultItemPropertiesComponent]
    });
  }
  return DxoDiagramDefaultItemPropertiesModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDiagramEdgesComponent = /*#__PURE__*/(() => {
  class DxoDiagramEdgesComponent extends NestedOption {
    get customDataExpr() {
      return this._getOption('customDataExpr');
    }
    set customDataExpr(value) {
      this._setOption('customDataExpr', value);
    }
    get dataSource() {
      return this._getOption('dataSource');
    }
    set dataSource(value) {
      this._setOption('dataSource', value);
    }
    get fromExpr() {
      return this._getOption('fromExpr');
    }
    set fromExpr(value) {
      this._setOption('fromExpr', value);
    }
    get fromLineEndExpr() {
      return this._getOption('fromLineEndExpr');
    }
    set fromLineEndExpr(value) {
      this._setOption('fromLineEndExpr', value);
    }
    get fromPointIndexExpr() {
      return this._getOption('fromPointIndexExpr');
    }
    set fromPointIndexExpr(value) {
      this._setOption('fromPointIndexExpr', value);
    }
    get keyExpr() {
      return this._getOption('keyExpr');
    }
    set keyExpr(value) {
      this._setOption('keyExpr', value);
    }
    get lineTypeExpr() {
      return this._getOption('lineTypeExpr');
    }
    set lineTypeExpr(value) {
      this._setOption('lineTypeExpr', value);
    }
    get lockedExpr() {
      return this._getOption('lockedExpr');
    }
    set lockedExpr(value) {
      this._setOption('lockedExpr', value);
    }
    get pointsExpr() {
      return this._getOption('pointsExpr');
    }
    set pointsExpr(value) {
      this._setOption('pointsExpr', value);
    }
    get styleExpr() {
      return this._getOption('styleExpr');
    }
    set styleExpr(value) {
      this._setOption('styleExpr', value);
    }
    get textExpr() {
      return this._getOption('textExpr');
    }
    set textExpr(value) {
      this._setOption('textExpr', value);
    }
    get textStyleExpr() {
      return this._getOption('textStyleExpr');
    }
    set textStyleExpr(value) {
      this._setOption('textStyleExpr', value);
    }
    get toExpr() {
      return this._getOption('toExpr');
    }
    set toExpr(value) {
      this._setOption('toExpr', value);
    }
    get toLineEndExpr() {
      return this._getOption('toLineEndExpr');
    }
    set toLineEndExpr(value) {
      this._setOption('toLineEndExpr', value);
    }
    get toPointIndexExpr() {
      return this._getOption('toPointIndexExpr');
    }
    set toPointIndexExpr(value) {
      this._setOption('toPointIndexExpr', value);
    }
    get zIndexExpr() {
      return this._getOption('zIndexExpr');
    }
    set zIndexExpr(value) {
      this._setOption('zIndexExpr', value);
    }
    get _optionPath() {
      return 'edges';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDiagramEdgesComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDiagramEdgesComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDiagramEdgesComponent,
      selectors: [["dxo-diagram-edges"]],
      inputs: {
        customDataExpr: "customDataExpr",
        dataSource: "dataSource",
        fromExpr: "fromExpr",
        fromLineEndExpr: "fromLineEndExpr",
        fromPointIndexExpr: "fromPointIndexExpr",
        keyExpr: "keyExpr",
        lineTypeExpr: "lineTypeExpr",
        lockedExpr: "lockedExpr",
        pointsExpr: "pointsExpr",
        styleExpr: "styleExpr",
        textExpr: "textExpr",
        textStyleExpr: "textStyleExpr",
        toExpr: "toExpr",
        toLineEndExpr: "toLineEndExpr",
        toPointIndexExpr: "toPointIndexExpr",
        zIndexExpr: "zIndexExpr"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDiagramEdgesComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDiagramEdgesComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDiagramEdgesModule = /*#__PURE__*/(() => {
  class DxoDiagramEdgesModule {
    /** @nocollapse */static ɵfac = function DxoDiagramEdgesModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDiagramEdgesModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDiagramEdgesModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDiagramEdgesComponent]
    });
  }
  return DxoDiagramEdgesModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDiagramEditingComponent = /*#__PURE__*/(() => {
  class DxoDiagramEditingComponent extends NestedOption {
    get allowAddShape() {
      return this._getOption('allowAddShape');
    }
    set allowAddShape(value) {
      this._setOption('allowAddShape', value);
    }
    get allowChangeConnection() {
      return this._getOption('allowChangeConnection');
    }
    set allowChangeConnection(value) {
      this._setOption('allowChangeConnection', value);
    }
    get allowChangeConnectorPoints() {
      return this._getOption('allowChangeConnectorPoints');
    }
    set allowChangeConnectorPoints(value) {
      this._setOption('allowChangeConnectorPoints', value);
    }
    get allowChangeConnectorText() {
      return this._getOption('allowChangeConnectorText');
    }
    set allowChangeConnectorText(value) {
      this._setOption('allowChangeConnectorText', value);
    }
    get allowChangeShapeText() {
      return this._getOption('allowChangeShapeText');
    }
    set allowChangeShapeText(value) {
      this._setOption('allowChangeShapeText', value);
    }
    get allowDeleteConnector() {
      return this._getOption('allowDeleteConnector');
    }
    set allowDeleteConnector(value) {
      this._setOption('allowDeleteConnector', value);
    }
    get allowDeleteShape() {
      return this._getOption('allowDeleteShape');
    }
    set allowDeleteShape(value) {
      this._setOption('allowDeleteShape', value);
    }
    get allowMoveShape() {
      return this._getOption('allowMoveShape');
    }
    set allowMoveShape(value) {
      this._setOption('allowMoveShape', value);
    }
    get allowResizeShape() {
      return this._getOption('allowResizeShape');
    }
    set allowResizeShape(value) {
      this._setOption('allowResizeShape', value);
    }
    get _optionPath() {
      return 'editing';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDiagramEditingComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDiagramEditingComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDiagramEditingComponent,
      selectors: [["dxo-diagram-editing"]],
      inputs: {
        allowAddShape: "allowAddShape",
        allowChangeConnection: "allowChangeConnection",
        allowChangeConnectorPoints: "allowChangeConnectorPoints",
        allowChangeConnectorText: "allowChangeConnectorText",
        allowChangeShapeText: "allowChangeShapeText",
        allowDeleteConnector: "allowDeleteConnector",
        allowDeleteShape: "allowDeleteShape",
        allowMoveShape: "allowMoveShape",
        allowResizeShape: "allowResizeShape"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDiagramEditingComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDiagramEditingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDiagramEditingModule = /*#__PURE__*/(() => {
  class DxoDiagramEditingModule {
    /** @nocollapse */static ɵfac = function DxoDiagramEditingModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDiagramEditingModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDiagramEditingModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDiagramEditingComponent]
    });
  }
  return DxoDiagramEditingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDiagramExportComponent = /*#__PURE__*/(() => {
  class DxoDiagramExportComponent extends NestedOption {
    get fileName() {
      return this._getOption('fileName');
    }
    set fileName(value) {
      this._setOption('fileName', value);
    }
    get _optionPath() {
      return 'export';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDiagramExportComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDiagramExportComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDiagramExportComponent,
      selectors: [["dxo-diagram-export"]],
      inputs: {
        fileName: "fileName"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDiagramExportComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDiagramExportComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDiagramExportModule = /*#__PURE__*/(() => {
  class DxoDiagramExportModule {
    /** @nocollapse */static ɵfac = function DxoDiagramExportModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDiagramExportModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDiagramExportModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDiagramExportComponent]
    });
  }
  return DxoDiagramExportModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDiagramGridSizeComponent = /*#__PURE__*/(() => {
  class DxoDiagramGridSizeComponent extends NestedOption {
    get items() {
      return this._getOption('items');
    }
    set items(value) {
      this._setOption('items', value);
    }
    get value() {
      return this._getOption('value');
    }
    set value(value) {
      this._setOption('value', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    valueChange;
    get _optionPath() {
      return 'gridSize';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'valueChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDiagramGridSizeComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDiagramGridSizeComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDiagramGridSizeComponent,
      selectors: [["dxo-diagram-grid-size"]],
      inputs: {
        items: "items",
        value: "value"
      },
      outputs: {
        valueChange: "valueChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDiagramGridSizeComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDiagramGridSizeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDiagramGridSizeModule = /*#__PURE__*/(() => {
  class DxoDiagramGridSizeModule {
    /** @nocollapse */static ɵfac = function DxoDiagramGridSizeModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDiagramGridSizeModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDiagramGridSizeModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDiagramGridSizeComponent]
    });
  }
  return DxoDiagramGridSizeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiDiagramGroupComponent = /*#__PURE__*/(() => {
  class DxiDiagramGroupComponent extends CollectionNestedOption {
    set _commandsContentChildren(value) {
      this.setChildren('commands', value);
    }
    get commands() {
      return this._getOption('commands');
    }
    set commands(value) {
      this._setOption('commands', value);
    }
    get title() {
      return this._getOption('title');
    }
    set title(value) {
      this._setOption('title', value);
    }
    get category() {
      return this._getOption('category');
    }
    set category(value) {
      this._setOption('category', value);
    }
    get displayMode() {
      return this._getOption('displayMode');
    }
    set displayMode(value) {
      this._setOption('displayMode', value);
    }
    get expanded() {
      return this._getOption('expanded');
    }
    set expanded(value) {
      this._setOption('expanded', value);
    }
    get shapes() {
      return this._getOption('shapes');
    }
    set shapes(value) {
      this._setOption('shapes', value);
    }
    get _optionPath() {
      return 'groups';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiDiagramGroupComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDiagramGroupComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiDiagramGroupComponent,
      selectors: [["dxi-diagram-group"]],
      contentQueries: function DxiDiagramGroupComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_commands, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._commandsContentChildren = _t);
        }
      },
      inputs: {
        commands: "commands",
        title: "title",
        category: "category",
        displayMode: "displayMode",
        expanded: "expanded",
        shapes: "shapes"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_groups,
        useExisting: DxiDiagramGroupComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiDiagramGroupComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiDiagramGroupComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiDiagramGroupModule = /*#__PURE__*/(() => {
  class DxiDiagramGroupModule {
    /** @nocollapse */static ɵfac = function DxiDiagramGroupModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDiagramGroupModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiDiagramGroupModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiDiagramGroupComponent]
    });
  }
  return DxiDiagramGroupModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDiagramHistoryToolbarComponent = /*#__PURE__*/(() => {
  class DxoDiagramHistoryToolbarComponent extends NestedOption {
    set _commandsContentChildren(value) {
      this.setChildren('commands', value);
    }
    get commands() {
      return this._getOption('commands');
    }
    set commands(value) {
      this._setOption('commands', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get _optionPath() {
      return 'historyToolbar';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDiagramHistoryToolbarComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDiagramHistoryToolbarComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDiagramHistoryToolbarComponent,
      selectors: [["dxo-diagram-history-toolbar"]],
      contentQueries: function DxoDiagramHistoryToolbarComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_commands, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._commandsContentChildren = _t);
        }
      },
      inputs: {
        commands: "commands",
        visible: "visible"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDiagramHistoryToolbarComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDiagramHistoryToolbarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDiagramHistoryToolbarModule = /*#__PURE__*/(() => {
  class DxoDiagramHistoryToolbarModule {
    /** @nocollapse */static ɵfac = function DxoDiagramHistoryToolbarModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDiagramHistoryToolbarModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDiagramHistoryToolbarModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDiagramHistoryToolbarComponent]
    });
  }
  return DxoDiagramHistoryToolbarModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiDiagramItemComponent = /*#__PURE__*/(() => {
  class DxiDiagramItemComponent extends CollectionNestedOption {
    set _itemsContentChildren(value) {
      this.setChildren('items', value);
    }
    get icon() {
      return this._getOption('icon');
    }
    set icon(value) {
      this._setOption('icon', value);
    }
    get items() {
      return this._getOption('items');
    }
    set items(value) {
      this._setOption('items', value);
    }
    get location() {
      return this._getOption('location');
    }
    set location(value) {
      this._setOption('location', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'items';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiDiagramItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDiagramItemComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiDiagramItemComponent,
      selectors: [["dxi-diagram-item"]],
      contentQueries: function DxiDiagramItemComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_items, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._itemsContentChildren = _t);
        }
      },
      inputs: {
        icon: "icon",
        items: "items",
        location: "location",
        name: "name",
        text: "text",
        height: "height",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_items,
        useExisting: DxiDiagramItemComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiDiagramItemComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiDiagramItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiDiagramItemModule = /*#__PURE__*/(() => {
  class DxiDiagramItemModule {
    /** @nocollapse */static ɵfac = function DxiDiagramItemModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDiagramItemModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiDiagramItemModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiDiagramItemComponent]
    });
  }
  return DxiDiagramItemModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDiagramMainToolbarComponent = /*#__PURE__*/(() => {
  class DxoDiagramMainToolbarComponent extends NestedOption {
    set _commandsContentChildren(value) {
      this.setChildren('commands', value);
    }
    get commands() {
      return this._getOption('commands');
    }
    set commands(value) {
      this._setOption('commands', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get _optionPath() {
      return 'mainToolbar';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDiagramMainToolbarComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDiagramMainToolbarComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDiagramMainToolbarComponent,
      selectors: [["dxo-diagram-main-toolbar"]],
      contentQueries: function DxoDiagramMainToolbarComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_commands, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._commandsContentChildren = _t);
        }
      },
      inputs: {
        commands: "commands",
        visible: "visible"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDiagramMainToolbarComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDiagramMainToolbarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDiagramMainToolbarModule = /*#__PURE__*/(() => {
  class DxoDiagramMainToolbarModule {
    /** @nocollapse */static ɵfac = function DxoDiagramMainToolbarModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDiagramMainToolbarModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDiagramMainToolbarModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDiagramMainToolbarComponent]
    });
  }
  return DxoDiagramMainToolbarModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDiagramNodesComponent = /*#__PURE__*/(() => {
  class DxoDiagramNodesComponent extends NestedOption {
    get autoLayout() {
      return this._getOption('autoLayout');
    }
    set autoLayout(value) {
      this._setOption('autoLayout', value);
    }
    get autoSizeEnabled() {
      return this._getOption('autoSizeEnabled');
    }
    set autoSizeEnabled(value) {
      this._setOption('autoSizeEnabled', value);
    }
    get containerChildrenExpr() {
      return this._getOption('containerChildrenExpr');
    }
    set containerChildrenExpr(value) {
      this._setOption('containerChildrenExpr', value);
    }
    get containerKeyExpr() {
      return this._getOption('containerKeyExpr');
    }
    set containerKeyExpr(value) {
      this._setOption('containerKeyExpr', value);
    }
    get customDataExpr() {
      return this._getOption('customDataExpr');
    }
    set customDataExpr(value) {
      this._setOption('customDataExpr', value);
    }
    get dataSource() {
      return this._getOption('dataSource');
    }
    set dataSource(value) {
      this._setOption('dataSource', value);
    }
    get heightExpr() {
      return this._getOption('heightExpr');
    }
    set heightExpr(value) {
      this._setOption('heightExpr', value);
    }
    get imageUrlExpr() {
      return this._getOption('imageUrlExpr');
    }
    set imageUrlExpr(value) {
      this._setOption('imageUrlExpr', value);
    }
    get itemsExpr() {
      return this._getOption('itemsExpr');
    }
    set itemsExpr(value) {
      this._setOption('itemsExpr', value);
    }
    get keyExpr() {
      return this._getOption('keyExpr');
    }
    set keyExpr(value) {
      this._setOption('keyExpr', value);
    }
    get leftExpr() {
      return this._getOption('leftExpr');
    }
    set leftExpr(value) {
      this._setOption('leftExpr', value);
    }
    get lockedExpr() {
      return this._getOption('lockedExpr');
    }
    set lockedExpr(value) {
      this._setOption('lockedExpr', value);
    }
    get parentKeyExpr() {
      return this._getOption('parentKeyExpr');
    }
    set parentKeyExpr(value) {
      this._setOption('parentKeyExpr', value);
    }
    get styleExpr() {
      return this._getOption('styleExpr');
    }
    set styleExpr(value) {
      this._setOption('styleExpr', value);
    }
    get textExpr() {
      return this._getOption('textExpr');
    }
    set textExpr(value) {
      this._setOption('textExpr', value);
    }
    get textStyleExpr() {
      return this._getOption('textStyleExpr');
    }
    set textStyleExpr(value) {
      this._setOption('textStyleExpr', value);
    }
    get topExpr() {
      return this._getOption('topExpr');
    }
    set topExpr(value) {
      this._setOption('topExpr', value);
    }
    get typeExpr() {
      return this._getOption('typeExpr');
    }
    set typeExpr(value) {
      this._setOption('typeExpr', value);
    }
    get widthExpr() {
      return this._getOption('widthExpr');
    }
    set widthExpr(value) {
      this._setOption('widthExpr', value);
    }
    get zIndexExpr() {
      return this._getOption('zIndexExpr');
    }
    set zIndexExpr(value) {
      this._setOption('zIndexExpr', value);
    }
    get _optionPath() {
      return 'nodes';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDiagramNodesComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDiagramNodesComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDiagramNodesComponent,
      selectors: [["dxo-diagram-nodes"]],
      inputs: {
        autoLayout: "autoLayout",
        autoSizeEnabled: "autoSizeEnabled",
        containerChildrenExpr: "containerChildrenExpr",
        containerKeyExpr: "containerKeyExpr",
        customDataExpr: "customDataExpr",
        dataSource: "dataSource",
        heightExpr: "heightExpr",
        imageUrlExpr: "imageUrlExpr",
        itemsExpr: "itemsExpr",
        keyExpr: "keyExpr",
        leftExpr: "leftExpr",
        lockedExpr: "lockedExpr",
        parentKeyExpr: "parentKeyExpr",
        styleExpr: "styleExpr",
        textExpr: "textExpr",
        textStyleExpr: "textStyleExpr",
        topExpr: "topExpr",
        typeExpr: "typeExpr",
        widthExpr: "widthExpr",
        zIndexExpr: "zIndexExpr"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDiagramNodesComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDiagramNodesComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDiagramNodesModule = /*#__PURE__*/(() => {
  class DxoDiagramNodesModule {
    /** @nocollapse */static ɵfac = function DxoDiagramNodesModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDiagramNodesModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDiagramNodesModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDiagramNodesComponent]
    });
  }
  return DxoDiagramNodesModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiDiagramPageSizeItemComponent = /*#__PURE__*/(() => {
  class DxiDiagramPageSizeItemComponent extends CollectionNestedOption {
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'items';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiDiagramPageSizeItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDiagramPageSizeItemComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiDiagramPageSizeItemComponent,
      selectors: [["dxi-diagram-page-size-item"]],
      inputs: {
        height: "height",
        text: "text",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_items,
        useExisting: DxiDiagramPageSizeItemComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiDiagramPageSizeItemComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiDiagramPageSizeItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiDiagramPageSizeItemModule = /*#__PURE__*/(() => {
  class DxiDiagramPageSizeItemModule {
    /** @nocollapse */static ɵfac = function DxiDiagramPageSizeItemModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDiagramPageSizeItemModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiDiagramPageSizeItemModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiDiagramPageSizeItemComponent]
    });
  }
  return DxiDiagramPageSizeItemModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDiagramPageSizeComponent = /*#__PURE__*/(() => {
  class DxoDiagramPageSizeComponent extends NestedOption {
    set _itemsContentChildren(value) {
      this.setChildren('items', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get items() {
      return this._getOption('items');
    }
    set items(value) {
      this._setOption('items', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    heightChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    widthChange;
    get _optionPath() {
      return 'pageSize';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'heightChange'
      }, {
        emit: 'widthChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDiagramPageSizeComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDiagramPageSizeComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDiagramPageSizeComponent,
      selectors: [["dxo-diagram-page-size"]],
      contentQueries: function DxoDiagramPageSizeComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_items, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._itemsContentChildren = _t);
        }
      },
      inputs: {
        height: "height",
        items: "items",
        width: "width"
      },
      outputs: {
        heightChange: "heightChange",
        widthChange: "widthChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDiagramPageSizeComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDiagramPageSizeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDiagramPageSizeModule = /*#__PURE__*/(() => {
  class DxoDiagramPageSizeModule {
    /** @nocollapse */static ɵfac = function DxoDiagramPageSizeModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDiagramPageSizeModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDiagramPageSizeModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDiagramPageSizeComponent]
    });
  }
  return DxoDiagramPageSizeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDiagramPropertiesPanelComponent = /*#__PURE__*/(() => {
  class DxoDiagramPropertiesPanelComponent extends NestedOption {
    set _tabsContentChildren(value) {
      this.setChildren('tabs', value);
    }
    get tabs() {
      return this._getOption('tabs');
    }
    set tabs(value) {
      this._setOption('tabs', value);
    }
    get visibility() {
      return this._getOption('visibility');
    }
    set visibility(value) {
      this._setOption('visibility', value);
    }
    get _optionPath() {
      return 'propertiesPanel';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDiagramPropertiesPanelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDiagramPropertiesPanelComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDiagramPropertiesPanelComponent,
      selectors: [["dxo-diagram-properties-panel"]],
      contentQueries: function DxoDiagramPropertiesPanelComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_tabs, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._tabsContentChildren = _t);
        }
      },
      inputs: {
        tabs: "tabs",
        visibility: "visibility"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDiagramPropertiesPanelComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDiagramPropertiesPanelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDiagramPropertiesPanelModule = /*#__PURE__*/(() => {
  class DxoDiagramPropertiesPanelModule {
    /** @nocollapse */static ɵfac = function DxoDiagramPropertiesPanelModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDiagramPropertiesPanelModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDiagramPropertiesPanelModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDiagramPropertiesPanelComponent]
    });
  }
  return DxoDiagramPropertiesPanelModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiDiagramTabComponent = /*#__PURE__*/(() => {
  class DxiDiagramTabComponent extends CollectionNestedOption {
    set _commandsContentChildren(value) {
      this.setChildren('commands', value);
    }
    set _groupsContentChildren(value) {
      this.setChildren('groups', value);
    }
    get commands() {
      return this._getOption('commands');
    }
    set commands(value) {
      this._setOption('commands', value);
    }
    get groups() {
      return this._getOption('groups');
    }
    set groups(value) {
      this._setOption('groups', value);
    }
    get title() {
      return this._getOption('title');
    }
    set title(value) {
      this._setOption('title', value);
    }
    get _optionPath() {
      return 'tabs';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiDiagramTabComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDiagramTabComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiDiagramTabComponent,
      selectors: [["dxi-diagram-tab"]],
      contentQueries: function DxiDiagramTabComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_commands, 4);
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_groups, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._commandsContentChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._groupsContentChildren = _t);
        }
      },
      inputs: {
        commands: "commands",
        groups: "groups",
        title: "title"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_tabs,
        useExisting: DxiDiagramTabComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiDiagramTabComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiDiagramTabComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiDiagramTabModule = /*#__PURE__*/(() => {
  class DxiDiagramTabModule {
    /** @nocollapse */static ɵfac = function DxiDiagramTabModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDiagramTabModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiDiagramTabModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiDiagramTabComponent]
    });
  }
  return DxiDiagramTabModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiDiagramTabGroupComponent = /*#__PURE__*/(() => {
  class DxiDiagramTabGroupComponent extends CollectionNestedOption {
    set _commandsContentChildren(value) {
      this.setChildren('commands', value);
    }
    get commands() {
      return this._getOption('commands');
    }
    set commands(value) {
      this._setOption('commands', value);
    }
    get title() {
      return this._getOption('title');
    }
    set title(value) {
      this._setOption('title', value);
    }
    get _optionPath() {
      return 'groups';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiDiagramTabGroupComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDiagramTabGroupComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiDiagramTabGroupComponent,
      selectors: [["dxi-diagram-tab-group"]],
      contentQueries: function DxiDiagramTabGroupComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_commands, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._commandsContentChildren = _t);
        }
      },
      inputs: {
        commands: "commands",
        title: "title"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_groups,
        useExisting: DxiDiagramTabGroupComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiDiagramTabGroupComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiDiagramTabGroupComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiDiagramTabGroupModule = /*#__PURE__*/(() => {
  class DxiDiagramTabGroupModule {
    /** @nocollapse */static ɵfac = function DxiDiagramTabGroupModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDiagramTabGroupModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiDiagramTabGroupModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiDiagramTabGroupComponent]
    });
  }
  return DxiDiagramTabGroupModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiDiagramToolboxGroupComponent = /*#__PURE__*/(() => {
  class DxiDiagramToolboxGroupComponent extends CollectionNestedOption {
    get category() {
      return this._getOption('category');
    }
    set category(value) {
      this._setOption('category', value);
    }
    get displayMode() {
      return this._getOption('displayMode');
    }
    set displayMode(value) {
      this._setOption('displayMode', value);
    }
    get expanded() {
      return this._getOption('expanded');
    }
    set expanded(value) {
      this._setOption('expanded', value);
    }
    get shapes() {
      return this._getOption('shapes');
    }
    set shapes(value) {
      this._setOption('shapes', value);
    }
    get title() {
      return this._getOption('title');
    }
    set title(value) {
      this._setOption('title', value);
    }
    get _optionPath() {
      return 'groups';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiDiagramToolboxGroupComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDiagramToolboxGroupComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiDiagramToolboxGroupComponent,
      selectors: [["dxi-diagram-toolbox-group"]],
      inputs: {
        category: "category",
        displayMode: "displayMode",
        expanded: "expanded",
        shapes: "shapes",
        title: "title"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_groups,
        useExisting: DxiDiagramToolboxGroupComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiDiagramToolboxGroupComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiDiagramToolboxGroupComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiDiagramToolboxGroupModule = /*#__PURE__*/(() => {
  class DxiDiagramToolboxGroupModule {
    /** @nocollapse */static ɵfac = function DxiDiagramToolboxGroupModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDiagramToolboxGroupModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiDiagramToolboxGroupModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiDiagramToolboxGroupComponent]
    });
  }
  return DxiDiagramToolboxGroupModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDiagramToolboxComponent = /*#__PURE__*/(() => {
  class DxoDiagramToolboxComponent extends NestedOption {
    set _groupsContentChildren(value) {
      this.setChildren('groups', value);
    }
    get groups() {
      return this._getOption('groups');
    }
    set groups(value) {
      this._setOption('groups', value);
    }
    get shapeIconsPerRow() {
      return this._getOption('shapeIconsPerRow');
    }
    set shapeIconsPerRow(value) {
      this._setOption('shapeIconsPerRow', value);
    }
    get showSearch() {
      return this._getOption('showSearch');
    }
    set showSearch(value) {
      this._setOption('showSearch', value);
    }
    get visibility() {
      return this._getOption('visibility');
    }
    set visibility(value) {
      this._setOption('visibility', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'toolbox';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDiagramToolboxComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDiagramToolboxComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDiagramToolboxComponent,
      selectors: [["dxo-diagram-toolbox"]],
      contentQueries: function DxoDiagramToolboxComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_groups, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._groupsContentChildren = _t);
        }
      },
      inputs: {
        groups: "groups",
        shapeIconsPerRow: "shapeIconsPerRow",
        showSearch: "showSearch",
        visibility: "visibility",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDiagramToolboxComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDiagramToolboxComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDiagramToolboxModule = /*#__PURE__*/(() => {
  class DxoDiagramToolboxModule {
    /** @nocollapse */static ɵfac = function DxoDiagramToolboxModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDiagramToolboxModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDiagramToolboxModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDiagramToolboxComponent]
    });
  }
  return DxoDiagramToolboxModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDiagramViewToolbarComponent = /*#__PURE__*/(() => {
  class DxoDiagramViewToolbarComponent extends NestedOption {
    set _commandsContentChildren(value) {
      this.setChildren('commands', value);
    }
    get commands() {
      return this._getOption('commands');
    }
    set commands(value) {
      this._setOption('commands', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get _optionPath() {
      return 'viewToolbar';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDiagramViewToolbarComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDiagramViewToolbarComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDiagramViewToolbarComponent,
      selectors: [["dxo-diagram-view-toolbar"]],
      contentQueries: function DxoDiagramViewToolbarComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_commands, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._commandsContentChildren = _t);
        }
      },
      inputs: {
        commands: "commands",
        visible: "visible"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDiagramViewToolbarComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDiagramViewToolbarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDiagramViewToolbarModule = /*#__PURE__*/(() => {
  class DxoDiagramViewToolbarModule {
    /** @nocollapse */static ɵfac = function DxoDiagramViewToolbarModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDiagramViewToolbarModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDiagramViewToolbarModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDiagramViewToolbarComponent]
    });
  }
  return DxoDiagramViewToolbarModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDiagramZoomLevelComponent = /*#__PURE__*/(() => {
  class DxoDiagramZoomLevelComponent extends NestedOption {
    get items() {
      return this._getOption('items');
    }
    set items(value) {
      this._setOption('items', value);
    }
    get value() {
      return this._getOption('value');
    }
    set value(value) {
      this._setOption('value', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    valueChange;
    get _optionPath() {
      return 'zoomLevel';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'valueChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDiagramZoomLevelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDiagramZoomLevelComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDiagramZoomLevelComponent,
      selectors: [["dxo-diagram-zoom-level"]],
      inputs: {
        items: "items",
        value: "value"
      },
      outputs: {
        valueChange: "valueChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDiagramZoomLevelComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDiagramZoomLevelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDiagramZoomLevelModule = /*#__PURE__*/(() => {
  class DxoDiagramZoomLevelModule {
    /** @nocollapse */static ɵfac = function DxoDiagramZoomLevelModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDiagramZoomLevelModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDiagramZoomLevelModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDiagramZoomLevelComponent]
    });
  }
  return DxoDiagramZoomLevelModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DxiDiagramCommandComponent, DxiDiagramCommandItemComponent, DxiDiagramCommandItemModule, DxiDiagramCommandModule, DxiDiagramConnectionPointComponent, DxiDiagramConnectionPointModule, DxiDiagramCustomShapeComponent, DxiDiagramCustomShapeModule, DxiDiagramGroupComponent, DxiDiagramGroupModule, DxiDiagramItemComponent, DxiDiagramItemModule, DxiDiagramPageSizeItemComponent, DxiDiagramPageSizeItemModule, DxiDiagramTabComponent, DxiDiagramTabGroupComponent, DxiDiagramTabGroupModule, DxiDiagramTabModule, DxiDiagramToolboxGroupComponent, DxiDiagramToolboxGroupModule, DxoDiagramAutoLayoutComponent, DxoDiagramAutoLayoutModule, DxoDiagramContextMenuComponent, DxoDiagramContextMenuModule, DxoDiagramContextToolboxComponent, DxoDiagramContextToolboxModule, DxoDiagramDefaultItemPropertiesComponent, DxoDiagramDefaultItemPropertiesModule, DxoDiagramEdgesComponent, DxoDiagramEdgesModule, DxoDiagramEditingComponent, DxoDiagramEditingModule, DxoDiagramExportComponent, DxoDiagramExportModule, DxoDiagramGridSizeComponent, DxoDiagramGridSizeModule, DxoDiagramHistoryToolbarComponent, DxoDiagramHistoryToolbarModule, DxoDiagramMainToolbarComponent, DxoDiagramMainToolbarModule, DxoDiagramNodesComponent, DxoDiagramNodesModule, DxoDiagramPageSizeComponent, DxoDiagramPageSizeModule, DxoDiagramPropertiesPanelComponent, DxoDiagramPropertiesPanelModule, DxoDiagramToolboxComponent, DxoDiagramToolboxModule, DxoDiagramViewToolbarComponent, DxoDiagramViewToolbarModule, DxoDiagramZoomLevelComponent, DxoDiagramZoomLevelModule };
